
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/uiAnimations/components/leftBarPanelsAnimation.scss.css.virtualfile';
        module.exports = {"wrapper":"_wrapper_16nqv_1","opened":"_opened_16nqv_1"};